module.exports = __webpack_public_path__ + "app-static/img/tbd.8622ba05.png";